import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import style from "./index.module.css";
import QrScannerComponent from "../Qr/QrScannerComponent";
import ModalWindow from "../ModalComponent/ModalWindow";
import ModalButton from "../../../../shared/Ui/Buttons/ModalButtons";
import { GoogleReCaptcha, GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { MarkSearch } from "../../../../common/api/nktApi";
import { normalizedLocale } from "../../../../common/libs/normalizedLocale";
import ModalComponent from "../../../../shared/Ui/ModalComponent/ModalWindow";
import Loader from "../../../../shared/Ui/Loader/Loader";
import StatusBadge from "../../../../shared/Ui/StatusBadge/StatusBadge";
import { getMarkStatusType } from "../../../../shared/documentUtils/dictionary";
import { product_groups } from "../../../../shared/reference/product_groups";


const LandingBody = () => {
  // Временный режим: открывать мок-данные без запроса при скане
  const USE_MOCK_MARK = false;
  const { executeRecaptcha } = useGoogleReCaptcha();
  const { t, i18n } = useTranslation();
  const [errorModal, setErrorModal] = useState<any>(null);
  const [isScannerOpen, setIsScannerOpen] = useState(false); // Состояние для управления видимостью сканера
  const [isModalOpen, setIsModalOpen] = useState(false); // Состояние для управления видимостью модалки
  const [scanResult, setScanResult] = useState<string | null>(null); // Состояние для хранения результата сканирования
  const [token,setToken] = useState<any>()
  const [isRequestPending, setIsRequestPending] = useState(false); // Добавьте флаг для управления запросами
  const [isLoadin, setIsLoading] = useState(false);
  const locale = normalizedLocale(i18n.language);
  const [isOpen1, setIsOpen1] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [isOpen3, setIsOpen3] = useState(false);
  const [isOpen4, setIsOpen4] = useState(false);
  const [initialValues,setInitialValues] =useState({
    markCode: "10001138900000Dn_=hz<21cc8236",
    weight: null,
    size: null,
    ntin: "00200120931837",
    status: "INFLICTED",
    nktCard: {
      nameRu: "Рога сайгака (Бетпак-дала)",
      nameKz: "Киік мүйіздері (Бетпақ дала)",
      ntin: "00200120931837",
      gtin: "GTIN_4",
      metal: "-",
      purity: "-",
      shortNameRu: "Рога сайгака",
      shortNameKz: "Киік мүйіздері",
      brand: "Рога сайгака (дериваты)",
      countryCode: "KZ",
      countryName: "КАЗАХСТАН",
      article: null,
      id: 200,
      createdAt: "05.11.2025 11:41:37",
      productCode: "10001138900000",
      kpved: [],
      tnved: [
        {
          tnvedCode: "0507900000",
          tnvedLabel: "Проч. панцири черепах, ус китовый или др. морских млекоп., рога, оленьи рога, копыта, ногти, клювы, когти, необработ. или подвергн. первичн. обработке без придан. формы; кр. порошка, отходы этих продуктов и слон. кости"
        },
        {
          tnvedCode: "0507900000",
          tnvedLabel: "Проч. панцири черепах, ус китовый или др. морских млекоп., рога, оленьи рога, копыта, ногти, клювы, когти, необработ. или подвергн. первичн. обработке без придан. формы; кр. порошка, отходы этих продуктов и слон. кости"
        }
      ],
      producerRu: "Республиканское государственное предприятие «Производственное объединение Охотзоопром»",
      producerKz: "\"Охотзоопром өндірістік бірлестігі\" республикалық мемлекеттік кәсіпорны",
      coatingRu: null,
      coatingKz: null,
      insertion: [],
      image: [],
      applicant: "930340000221",
      oktruLabelRu: "Рога сайгака",
      oktruCode: "0507900000",
      szpt: false,
      mpnCode: null,
      measureUnitLabelRu: "шт",
      measureUnitCode: "796",
      weightNetto: 1.0,
      weightNettoMeasureUnitLabelRu: "кг",
      weightNettoMeasureUnitCode: "166",
      producerBinIin: "930340000221",
      population: "Бетпак-дала"
    },
    gasInfo: null,
    woodInfo: null,
    derivativeInfo: {
      hornLengthCm: 12.0,
      extractionDate: "04.12.2025",
      employee: "АРНУР АБАИЛДАЕВ",
      sourceCode: "W",
      sort: "3"
    }
  }) 

  useEffect(() => {
    const loadToken = async () => {
      if (!executeRecaptcha) {
        console.log("reCAPTCHA не загружена");
        return;
      }
      try {
        const token = await executeRecaptcha("action_name");
        setToken(token);
        console.log("reCAPTCHA token:", token);
      } catch (e) {
        console.error("reCAPTCHA error", e);
      }
    };
  
    loadToken(); 
  }, []); 

  
  const handleScanButtonClick = () => {
    setIsScannerOpen(true); // Открываем сканер при нажатии на кнопку
  };

  const handleCloseScanner = () => {
    setIsScannerOpen(false); // Закрываем сканер
  };
  const handleScanResult = async (result: string) => {
    try {
      if (isRequestPending) return
      setIsRequestPending(true)
      // if (!USE_MOCK_MARK) {
      //   if (result.length !== 29) {
      //     setIsScannerOpen(false)
      //     setErrorModal(t("qrScaner.simbolsError"));
      //     setIsRequestPending(false)
      //     return; 
      //   }
      // }

      setScanResult(result);
  
      // Мок-режим: сразу открываем модалку c мок-данными, подменяя код марки
      // if (USE_MOCK_MARK) {
      //   // В режиме разработки не перетираем код из initialValues,
      //   // просто открываем модалку с текущими данными
      //   setIsModalOpen(true);
      //   setIsRequestPending(false);
      //   setIsScannerOpen(false);
      //   return;
      // }

      if (!executeRecaptcha) {
        console.error("reCAPTCHA не загружена");
        return;
      }
  
      const token = await executeRecaptcha("action_name");
      if (!token) {
        console.error("Не удалось получить reCAPTCHA токен");
        return;
      }
setIsLoading(true)
      const response = await MarkSearch(result, token); 
      if (response) {
        console.log('response',response);
        setInitialValues(response);
        setIsModalOpen(true);
      } else {
      }
    } catch (error: any) {
      console.log(error,'error');
      const rawMessage = typeof error?.response?.data?.message === 'string'
        ? error.response.data.message
        : (typeof error?.message === 'string' ? error.message : String(error));
      setErrorModal(replaceFieldNames(rawMessage));
    }
    setIsLoading(false)
    setIsRequestPending(false)
    console.log('initial',initialValues);
    setIsScannerOpen(false);
    
  };
  
  const replaceFieldNames = (message?: string): string => {
    if (!message || typeof message !== 'string') return t("documentNotification.notification");
    const fieldNamesMap: { [key: string]: string } = {
      "ISSUED": t("documents_file_upload.code_status_issued"),
      "INFLICTED": t("documents_file_upload.code_status_inflicted"),
      "IN_CIRCULATION": t("documents_file_upload.code_status_in_circulation"),
      "WITHDRAWN_FROM_CIRCULATION": t("documents_file_upload.code_status_withdrawn"),
      "PRE_SALE": t("NewCheque.PRE_SALE"),
      "DEAGGREGATED": t("marking_codes.status_deaggregated"),
      "AGGREGATED": t("marking_codes.status_aggregated"),
    };
    for (const englishName in fieldNamesMap) {
      if (message.includes(englishName)) {
        message = message.replace(englishName, fieldNamesMap[englishName]);
      }
    }
  
    return message;
  };
  
  if (isLoadin) return <Loader />;
  
  const body = () => {
    // Товарная группа только по данным марки
    const inferredGroupCode = (() => {
      const data: any = initialValues;
      if (data?.woodInfo) return "002"; // Древесина
      if (data?.gasInfo) return "003"; // Сжиженный газ
      if (data?.derivativeInfo) return "004"; // Дериваты
      return null;
    })();

    const currentGroup: any =
      (inferredGroupCode && product_groups.find((pg: any) => pg.code === inferredGroupCode))
      || product_groups[0];

    const cardCategory: any = currentGroup?.categories?.find((c: any) => c.key === "card");
    const descriptionCategory: any = currentGroup?.categories?.find((c: any) => c.key === "description");
    const characteristicsCategory: any = currentGroup?.categories?.find((c: any) => c.key === "characteristics");
    const personalCategory: any = currentGroup?.categories?.find((c: any) => c.key === "personal" || c.key === "personalCharacteristics");

    // Если активная группа не содержит категории "Персональные характеристики",
    // но в ответе есть derivativeInfo, показываем динамически с дефолтными лейблами
    const hasDerivativeInfo: boolean = Boolean(
      (initialValues as any)?.derivativeInfo
      && (
        (initialValues as any)?.derivativeInfo?.hornLengthCm != null
        || (initialValues as any)?.derivativeInfo?.extractionDate
        || (initialValues as any)?.derivativeInfo?.sourceCode
        || (initialValues as any)?.derivativeInfo?.sort
      )
    );
    const personalCategoryEffective: any = !inferredGroupCode
      ? {
        key: "personal",
        labelRu: "Персональные характеристики",
        labelKz: "Жеке сипаттамалар",
        fields: [
          { labelRu: i18n.getFixedT("ru")("productPersonalization.weight"), labelKz: i18n.getFixedT("kk")("productPersonalization.weight"), valuePath: "weight" },
          { labelRu: i18n.getFixedT("ru")("productPersonalization.size"), labelKz: i18n.getFixedT("kk")("productPersonalization.size"), valuePath: "size" },
        ],
      }
      : (personalCategory || (hasDerivativeInfo ? {
        key: "personal",
        labelRu: "Персональные характеристики",
        labelKz: "Жеке сипаттамалар",
        fields: [
          { labelRu: "Длина рога (см)", labelKz: "Мүйіз ұзындығы (см)", valuePath: "derivativeInfo.hornLengthCm" },
          { labelRu: "Дата изъятия", labelKz: "Алу күні", valuePath: "derivativeInfo.extractionDate" },
          { labelRu: "Источник происхождения (код)", labelKz: "Шығу көзі (код)", valuePath: "derivativeInfo.sourceCode" },
          { labelRu: "Сорт", labelKz: "Сорт", valuePath: "derivativeInfo.sort" },
        ],
      } : null));
    const insertionCategory: any = currentGroup?.categories?.find((c: any) => c.key === "insertion" || c.key === "inserts");
    const showInsertsSection: boolean = Boolean(
      (characteristicsCategory?.fields?.some((f: any) => f.value === "insertion" || f.value === "inserts"))
      || insertionCategory
    );

    const getCategoryLabel = (category: any, fallbackKey: string) => {
      if (!category) return t(fallbackKey);
      return locale === 'ru' ? category.labelRu : category.labelKz;
    };

    // Корень данных карточки товара для чтения полей из json-схемы
    const product: any = initialValues?.nktCard ?? initialValues;

    const isPlaceholderString = (val: string): boolean => {
      const v = (val || "").trim().toLowerCase();
      return v === "string" || v === "stringstringst" || v === "st" || v === "dddddd";
    };

    const cleanupValue = (value: any): any => {
      if (value == null) return undefined;
      if (Array.isArray(value) && value.length === 0) return undefined;
      if (typeof value === "string") {
        if (isPlaceholderString(value) || value.trim() === "") return undefined;
      }
      return value;
    };

    const readFieldValue = (field: any): any => {
      if (!field) return undefined;
      // Локализованные ключи
      if (field.valueRu || field.valueKz) {
        const localizedKey = locale === 'ru' ? field.valueRu : field.valueKz;
        if (localizedKey) {
          const fromProduct = cleanupValue(product?.[localizedKey]);
          if (fromProduct !== undefined) return fromProduct;
          return cleanupValue((initialValues as any)?.[localizedKey]);
        }
      }
      // Путь вида a.b.0.c
      if (field.valuePath && typeof field.valuePath === 'string') {
        const parts = field.valuePath.split('.');
        // Сначала читаем из product (обычно nktCard)
        let acc: any = product;
        for (const p of parts) {
          if (acc == null) break;
          const index = Number(p);
          acc = Number.isInteger(index) && String(index) === p ? acc?.[index] : acc?.[p];
        }
        const fromProduct = cleanupValue(acc);
        if (fromProduct !== undefined) return fromProduct;
        // Затем пробуем корень initialValues (для полей вне nktCard, например derivativeInfo.*)
        let accRoot: any = initialValues as any;
        for (const p of parts) {
          if (accRoot == null) break;
          const index = Number(p);
          accRoot = Number.isInteger(index) && String(index) === p ? accRoot?.[index] : accRoot?.[p];
        }
        return cleanupValue(accRoot);
      }
      // Прямой ключ
      if (field.value) {
        const fromProduct = cleanupValue(product?.[field.value]);
        if (fromProduct !== undefined) return fromProduct;
        return cleanupValue((initialValues as any)?.[field.value]);
      }
      return undefined;
    };

    const isTnvedCodeField = (field: any) =>
      typeof field?.valuePath === "string" &&
      field.valuePath.includes("tnved") &&
      field.valuePath.includes("tnvedCode");

    const isProducerField = (field: any) => {
      const keys = [field?.value, field?.valueRu, field?.valueKz, field?.valuePath]
        .filter(Boolean)
        .map(String);
      return keys.some(
        (key) =>
          key === "producerRu" ||
          key === "producerKz" ||
          key === "producerBinIin" ||
          key.includes("producer"),
      );
    };

    const getFieldLabel = (field: any) => {
      const keys = [field?.valueRu, field?.valueKz, field?.value, field?.valuePath]
        .filter(Boolean)
        .map(String);
      if (keys.some((k) => k === "nameRu" || k === "nameKz")) {
        return locale === "ru" ? "Полное наименование" : "Толық атауы";
      }
      if (keys.some((k) => k === "shortNameRu" || k === "shortNameKz")) {
        return locale === "ru" ? "Краткое наименование" : "Қысқаша атауы";
      }
      return locale === "ru" ? field.labelRu : field.labelKz;
    };

    const descriptionFields =
      descriptionCategory?.fields?.filter((f: any) => !isProducerField(f)) ?? [];

    const renderFieldValue = (field: any) => {
      if (isTnvedCodeField(field)) {
        const items = Array.isArray(product?.tnved)
          ? product.tnved
          : Array.isArray((initialValues as any)?.tnved)
            ? (initialValues as any).tnved
            : [];
        if (!items.length) {
          return <p className="font-light">-</p>;
        }
        return (
          <div className="flex flex-wrap gap-2 mt-1">
            {items.map((item: any, index: number) => (
              <span
                key={`${item?.tnvedCode ?? "tnved"}-${index}`}
                title={item?.tnvedLabel || undefined}
                className="inline-flex items-center px-2.5 py-1 rounded-md bg-emerald-50 text-emerald-800 text-sm font-medium border border-emerald-200"
              >
                {item?.tnvedCode || "-"}
              </span>
            ))}
          </div>
        );
      }

      const value = readFieldValue(field);
      return <p className="font-light">{value ? value : "-"}</p>;
    };

    return (
      <>
        <div className="w-full flex flex-col bg-white rounded-3xl p-[30px] gap-[30px]">
          <div className="flex items-center text-base text-gray-600 font-light gap-x-[10px]">
            <img src="/assets/docs.png" className="w-[20px]" />
            <div className="uppercase"> {getCategoryLabel(cardCategory, "productCard.title")}</div>
          </div>

          <div className="flex gap-x-[20px] gap-y-[20px] text-base flex-wrap justify-between after:block after:w-full after:h-[1px] border-b-[2px] pb-[20px]">
            <div className="flex flex-col gap-[30px] justify-between flex-wrap max-w-[calc(67%-20px)] w-full ">
              <div className="flex flex-row justify-between gap-[20px] flex-wrap ">
                {cardCategory?.fields?.map((f: any) => (
                  <div key={(f.value ?? f.valueRu ?? f.valueKz ?? f.valuePath) as string} className="w-full max-w-[calc(50%-10px)] min-w-0 basis-[calc(50%-10px)]">
                    {getFieldLabel(f)}
                    <p className="font-light break-words">{readFieldValue(f) ? readFieldValue(f) : '-'}</p>
                  </div>
                ))}
                {/* Дополнительно выводим код марки и статус, если есть */}
                {initialValues?.markCode ? (
                  <div className="w-full max-w-[calc(50%-10px)] min-w-0 basis-[calc(50%-10px)] overflow-hidden">
                    {t("CheckResult.code")}
                    <p className="font-light break-all whitespace-normal leading-snug">
                      {initialValues.markCode}
                    </p>
                  </div>
                ) : null}
                {initialValues?.status ? (
                  <div className="w-full max-w-[calc(50%-10px)] min-w-0 basis-[calc(50%-10px)]">
                    {t("qrScaner.markStatus")}<div>
                      <StatusBadge
                        type={getMarkStatusType(initialValues?.status, t).type}
                        fontSize="15px"
                        circleSize="8px"
                      >
                        {getMarkStatusType(initialValues?.status, t).label}
                      </StatusBadge>
                    </div>
                  </div>
                ) : null}
                {(() => {
                  const owner = (initialValues as any)?.markOwner;
                  const iinBin = cleanupValue(owner?.iinBin);
                  const name = cleanupValue(
                    locale === "ru" ? owner?.nameRu : owner?.nameKk,
                  ) ?? cleanupValue(owner?.nameRu) ?? cleanupValue(owner?.nameKk);
                  if (iinBin == null && name == null) return null;
                  return (
                    <div className="w-full max-w-[calc(50%-10px)] min-w-0 basis-[calc(50%-10px)]">
                      {t("qrScaner.markOwner")}
                      <p className="font-light break-words">{iinBin ?? "-"}</p>
                      <p className="font-light break-words">{name ?? "-"}</p>
                    </div>
                  );
                })()}
                {(() => {
                  const issuer = (initialValues as any)?.markIssuer;
                  const iinBin = cleanupValue(issuer?.iinBin);
                  const name = cleanupValue(
                    locale === "ru" ? issuer?.nameRu : issuer?.nameKk,
                  ) ?? cleanupValue(issuer?.nameRu) ?? cleanupValue(issuer?.nameKk);
                  if (iinBin == null && name == null) return null;
                  return (
                    <div className="w-full max-w-[calc(50%-10px)] min-w-0 basis-[calc(50%-10px)]">
                      {t("qrScaner.markIssuer")}
                      <p className="font-light break-words">{iinBin ?? "-"}</p>
                      <p className="font-light break-words">{name ?? "-"}</p>
                    </div>
                  );
                })()}
                {inferredGroupCode === "003"
                  ? (() => {
                      const org = (initialValues as any)?.personalizationOrg;
                      const iinBin = cleanupValue(org?.iinBin);
                      const name =
                        cleanupValue(
                          locale === "ru" ? org?.nameRu : org?.nameKk,
                        ) ??
                        cleanupValue(org?.nameRu) ??
                        cleanupValue(org?.nameKk);
                      const address = cleanupValue(org?.address);
                      const buyerAddress = cleanupValue(
                        (initialValues as any)?.buyerAddress,
                      );
                      const withdrawnAt = cleanupValue(
                        (initialValues as any)?.withdrawnAt,
                      );
                      // buyerAddress / withdrawnAt бэк отдаёт только при причине «Продажа»
                      const showSaleWithdraw =
                        String(initialValues?.status || "").toUpperCase() ===
                          "WITHDRAWN_FROM_CIRCULATION" &&
                        (buyerAddress != null || withdrawnAt != null);

                      return (
                        <>
                          <div className="w-full max-w-[calc(50%-10px)] min-w-0 basis-[calc(50%-10px)]">
                            {t("qrScaner.personalizationUotBin")}
                            <p className="font-light break-words">
                              {iinBin ?? "-"}
                            </p>
                          </div>
                          <div className="w-full max-w-[calc(50%-10px)] min-w-0 basis-[calc(50%-10px)]">
                            {t("qrScaner.personalizationUotName")}
                            <p className="font-light break-words">
                              {name ?? "-"}
                            </p>
                          </div>
                          <div className="w-full max-w-[calc(50%-10px)] min-w-0 basis-[calc(50%-10px)]">
                            {t("qrScaner.personalizationUotAddress")}
                            <p className="font-light break-words">
                              {address ?? "-"}
                            </p>
                          </div>
                          {showSaleWithdraw ? (
                            <>
                              <div className="w-full max-w-[calc(50%-10px)] min-w-0 basis-[calc(50%-10px)]">
                                {t("qrScaner.buyerAddress")}
                                <p className="font-light break-words">
                                  {buyerAddress ?? "-"}
                                </p>
                              </div>
                              <div className="w-full max-w-[calc(50%-10px)] min-w-0 basis-[calc(50%-10px)]">
                                {t("qrScaner.withdrawnAt")}
                                <p className="font-light break-words">
                                  {withdrawnAt ?? "-"}
                                </p>
                              </div>
                            </>
                          ) : null}
                        </>
                      );
                    })()
                  : null}
              </div>
            </div>
            <div className="text-gray-600 justify-center  flex-1 w-full min-w-[200px] max-w-[calc(33%-10px)] h-[200px] flex flex-wrap">
              <div className="text-gray-600  rounded-[10px] w-[200px] h-[200px] font-semibold ">
                {(() => {
                  const imageUrl = product?.image?.[0]?.imageUrl as string | undefined;
                  const validUrl = typeof imageUrl === 'string' && !isPlaceholderString(imageUrl) && /^(https?:)?\/\//i.test(imageUrl);
                  return validUrl ? (
                  <img
                    src={imageUrl as string}
                    alt={typeof product?.nameRu === 'string' && !isPlaceholderString(product?.nameRu) ? product?.nameRu : ''}
                    className="w-48 h-48 object-cover"
                  />
                  ) : null;
                })()}
              </div>
            </div>
          </div>
        </div>

        <div className="w-full flex flex-col bg-white rounded-3xl p-[30px] gap-[30px] max-w-[1200px]">
          <div
            className=" flex items-center text-base text-gray-600 font-light gap-x-[10px] cursor-pointer pb-[20px] border-b-[2px] "
            onClick={() => setIsOpen1(!isOpen1)}
          >
            <img src={"/assets/docs.png"} className="w-[20px]" alt="icon" />
            <div className="uppercase ">{getCategoryLabel(descriptionCategory, "productCard.productDescription")}</div>
            <div
              className={`ml-auto transform transition-transform duration-300 ${isOpen1 ? "rotate-180" : "rotate-0"}`}
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
              </svg>
            </div>
          </div>
          <div className={`transition-max-height duration-500 ease-in-out overflow-hidden ${isOpen1 ? "max-h-screen" : "max-h-0"} `}>
            <div className="flex flex-wrap gap-[20px] ">
              {descriptionFields.map((f: any) => (
                <div key={(f.value ?? f.valueRu ?? f.valueKz ?? f.valuePath) as string} className="w-full min-w-[200px] max-w-[calc(33%-10px)]">
                  <div className="text-gray-600 font-semibold">
                    {getFieldLabel(f)}
                    {renderFieldValue(f)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="w-full flex flex-col bg-white rounded-3xl p-[30px] gap-[30px] max-w-[1200px]">
          <div
            className="flex items-center text-base text-gray-600 font-light gap-x-[10px] cursor-pointer pb-[20px] border-b-[2px]"
            onClick={() => setIsOpen2(!isOpen2)}
          >
            <img src="/assets/docs.png" className="w-[20px]" alt="icon" />
            <div className="uppercase">{getCategoryLabel(characteristicsCategory, "productCard.productCharacteristics")}</div>
            <div className={`ml-auto transform transition-transform duration-300 ${isOpen2 ? "rotate-180" : "rotate-0"}`}>
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
              </svg>
            </div>
          </div>
          <div className={`transition-max-height duration-500 ease-in-out overflow-hidden ${isOpen2 ? "max-h-screen" : "max-h-0"}`}>
            <div className="flex flex-wrap gap-[20px] ">
              {characteristicsCategory?.fields?.filter((f: any) => f.value !== 'inserts' && f.value !== 'insertion').map((f: any) => (
                <div key={(f.value ?? f.valueRu ?? f.valueKz ?? f.valuePath) as string} className="w-full min-w-[200px] max-w-[calc(33%-10px)]">
                  <div className="text-gray-600 font-semibold">
                    {locale === 'ru' ? f.labelRu : f.labelKz}
                    <p className="font-light">{readFieldValue(f) ? readFieldValue(f) : '-'}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {personalCategoryEffective ? (
          <div className="w-full flex flex-col bg-white rounded-3xl p-[30px] gap-[30px] max-w-[1200px]">
            <div
              className="flex items-center text-base text-gray-600 font-light gap-x-[10px] cursor-pointer pb-[20px] border-b-[2px]"
              onClick={() => setIsOpen4(!isOpen4)}
            >
              <img src="/assets/docs.png" className="w-[20px]" alt="icon" />
              <div className="uppercase">{getCategoryLabel(personalCategoryEffective, "productCard.productCharacteristics")}</div>
              <div className={`ml-auto transform transition-transform duration-300 ${isOpen4 ? "rotate-180" : "rotate-0"}`}>
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                </svg>
              </div>
            </div>
            <div className={`transition-max-height duration-500 ease-in-out overflow-hidden ${isOpen4 ? "max-h-screen" : "max-h-0"}`}>
              <div className="flex flex-wrap gap-[20px] ">
                {personalCategoryEffective?.fields?.map((f: any) => (
                  <div key={(f.value ?? f.valueRu ?? f.valueKz ?? f.valuePath) as string} className="w-full min-w-[200px] max-w-[calc(33%-10px)]">
                    <div className="text-gray-600 font-semibold">
                      {locale === 'ru' ? f.labelRu : f.labelKz}
                      <p className="font-light">{readFieldValue(f) ? readFieldValue(f) : '-'}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : null}

        {showInsertsSection ? (
          <div className="w-full flex flex-col bg-white rounded-3xl p-[30px] gap-[30px] max-w-[1200px]">
            <div className="flex w-full items-center text-base text-gray-600 font-light gap-x-[10px] cursor-pointer"
              onClick={() => setIsOpen3(!isOpen3)}
            >
              <img src="/assets/docs.png" className="w-[20px]" />
              <div className="uppercase">{insertionCategory ? getCategoryLabel(insertionCategory, "productCard.inserts") : t("productCard.inserts")}</div>
              <div className={`ml-auto transform transition-transform duration-300 ${isOpen3 ? "rotate-180" : "rotate-0"}`}>
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                </svg>
              </div>
            </div>
            <div className={`transition-max-height duration-500 ease-in-out overflow-hidden ${isOpen3 ? "max-h-screen" : "max-h-0"}`}>
              <table className="max-w-full w-full leading-normal">
                <thead className="border-b-2 border-gray-300">
                  <tr>
                    <th className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200" scope="col">
                      {t("productCard.insertMaterial")}
                    </th>
                    <th className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200" scope="col">
                      {t("productCard.insertCount")}
                    </th>
                    <th className="px-5 py-3 text-center items-center text-gray-600 font-semibold bg-white border-b border-gray-200 flex justify-center" scope="col">
                      {t("productCard.weight")}
                    </th>
                  </tr>
                </thead>
                <tbody className="font-normal text-center">
                  {Array.isArray(product?.insertion) && product.insertion.map((value: any, index: any) => (
                    <tr key={`ins-${index}`}>
                      <td className="px-5 py-5 text-sm bg-white border-b border-gray-200 text-gray-600">{value.insertionMaterial}</td>
                      <td className="px-5 py-5 text-sm bg-white border-b border-gray-200 text-gray-600">{value.insertionCount}</td>
                      <td className="px-5 py-5 text-sm bg-white border-b border-gray-200 text-gray-600">{value.insertionWeight}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ) : null}
        <div className="flex justify-end">
        <ModalButton
                type="button"
                onClick={()=>setIsModalOpen(false)}
                color={'green'}
              >
                {t("mainButtons.close")}
              </ModalButton>
        <div className="pb-[2px]"></div>
      </div>
     
      </>
    );
  };
  

  return (<>
<ModalComponent
  isOpen={errorModal }
  onClose={() => setErrorModal(null)}
  headerContent={
    <h1 className="h__modal">
      {t("documentNotification.notification")}
    </h1>
  }
  content={
    <div className="error-list">
      <ul>
        {Array.isArray(errorModal) && errorModal.length > 0 ? (
          errorModal.map((error: any, index: any) => (
            <li className="border-b border-gray-300 py-1" key={index}>
              {t(`error_dictionary.${error}`)}
            </li>
          ))
        ) : typeof errorModal === "string" ? (
          <li>{errorModal}</li> 
        ) : (
          <li>{t("documentNotification.no_errors")}</li>
        )}
      </ul>
    </div>
  }
  customContent={
    <ModalButton
      type="button"
      onClick={() => {
        setErrorModal(null);
      }}
    >
      {t("mainButtons.accept")}
    </ModalButton>
  }
/>


  
    <div className={style.container}>
      <div className={style.middleContainer}>
        <button className={style.middleButton} onClick={handleScanButtonClick}>
          <img
            src={"/icons/datamatrix.svg"}
            alt="E-Track Logo"
            className={`h-6 pl-2 origin-left font-medium text-xl duration-200 brightness-0 invert`}
          />
          {t("qrScaner.mainButton")}
        </button>
        {/* <button
      className="m-auto"
      onClick={async () => {
        if (executeRecaptcha) {
          const token = await executeRecaptcha("action_name");
          console.log("token:", token);
        } else {
          console.warn("executeRecaptcha is undefined");
        }
      }}
    >
      Получить токен
    </button> */}
      </div>
      
      {/* Отображаем компонент сканера, если он открыт */}
      {isScannerOpen && (
        <div className={style.scannerOverlay}>
          <QrScannerComponent onClose={handleCloseScanner} onScanResult={handleScanResult} />
        </div>
      )}

      {/* Модалка для отображения результата сканирования */}
    <ModalWindow isOpen={isModalOpen} onClose={()=>setIsModalOpen(false)} headerContent={t("Результат сканирования")} 
    content={body()}
    />
    </div>
     </>
  );
 
};

export default LandingBody;
